import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press',
  templateUrl: './notice-press.component.html',
  styleUrls: ['./notice-press.component.scss']
})
export class NoticePressComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
